import React from 'react';
import { withPermissionsAndRoles } from '../../session';
import { hasUserRole } from '../../common';
import NotificationIcon from './notificationIcon';
import HelpIcon from './helpIcon';

function TopMenuOptions({ roles = [] }) {
  return (
    <>
    {hasUserRole(roles) && <>
      <NotificationIcon/>
      <HelpIcon/>
    </>}
    </>
  );
}

export default withPermissionsAndRoles(TopMenuOptions);
